import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {useFileDownload} from 'hooks/api/useFileDownload'

export const useDownloadAttachment = () => {
  const authAxios = useAuthAxios()
  const {download} = useFileDownload()

  return async (egovProcedureId: string, attachmentId: string) => {
    const path = `/api/egov_procedure_statuses/${egovProcedureId}/attachments/${attachmentId}`
    const getter = () => authAxios.get(path, {responseType: 'arraybuffer'})

    download(getter)
  }
}
